import { cn } from '@/lib/utils';
import { scoreBarColor } from '../lib/combinedRiskDisplay';

export function SignalScoreBar({
  score,
  label,
  threshold,
}: {
  score: number;
  label: string;
  threshold?: number;
}) {
  const pct = Math.min(Math.max(score, 0), 1) * 100;
  const thresholdPct = threshold != null ? Math.min(Math.max(threshold, 0), 1) * 100 : null;

  return (
    <div className="flex items-center gap-3">
      <span className="w-32 shrink-0 truncate text-xs text-muted-foreground">{label}</span>
      <div className="relative h-2 flex-1 rounded-full bg-muted">
        <div
          className={cn('h-full rounded-full transition-all', scoreBarColor(score))}
          style={{ width: `${pct}%` }}
        />
        {thresholdPct != null && (
          <div
            className="absolute top-0 h-full w-px bg-foreground/40"
            style={{ left: `${thresholdPct}%` }}
            title={`Threshold: ${threshold!.toFixed(3)}`}
          />
        )}
      </div>
      <span className="w-12 shrink-0 text-right text-xs font-medium tabular-nums">
        {score.toFixed(3)}
      </span>
    </div>
  );
}
